import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["serviceSelect", "batchSelect"]
  static values  = { batchesUrl: String }

  connect() {
    $(this.serviceSelectTarget).on("change.curriculumGantt", () => this.loadBatches())
  }

  disconnect() {
    $(this.serviceSelectTarget).off("change.curriculumGantt")
  }

  async loadBatches() {
    const serviceId = this.serviceSelectTarget.value
    const url       = new URL(this.batchesUrlValue, window.location.origin)

    if (serviceId) url.searchParams.set("service_id", serviceId)

    const response = await fetch(url, { headers: { Accept: "application/json" } })
    const batches  = await response.json()

    const $select = $(this.batchSelectTarget)
    $select.empty().append(new Option("Todas as turmas", ""))
    batches.forEach(b => $select.append(new Option(b.name, b.id)))
    $select.trigger("change")
  }
}
